export const FILES = {
  package: "package.json",
  tsconfig: "tsconfig.json",
  jsconfig: "jsconfig.json",
};